import { render, staticRenderFns } from "./product-specs-modal.vue?vue&type=template&id=2e9ea180&scoped=true"
import script from "./product-specs-modal.vue?vue&type=script&lang=js"
export * from "./product-specs-modal.vue?vue&type=script&lang=js"
import style0 from "./product-specs-modal.vue?vue&type=style&index=0&id=2e9ea180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ea180",
  null
  
)

export default component.exports